import {FC} from "react";
import {ChatHint, ChatHints} from "../molecules/ChatHint.tsx";
import useTranslations from "../store/translations.ts";
import {AlarmIcon, ElectricityIcon, HumidityLowIcon, WifiSquareIcon} from "../atoms/Icon";
import {FeedbackPageSettings} from "../api/site.ts";

interface Props {
    onMessage: (text: string) => void
    settings?: FeedbackPageSettings
}

const IssueReportingChatHints: FC<Props> = ({ onMessage, settings }) => {
    const translations = useTranslations();

    if (settings && settings.messageHints) {
        return <ChatHints>
            {settings.messageHints.map((hint, index) =>
                <ChatHint key={index} text={hint.label} onClick={() => onMessage(hint.message)} />
            )}
        </ChatHints>
    }

    return <ChatHints>
        <ChatHint text={translations.chatHints.internetIssue} icon={WifiSquareIcon} onClick={() => onMessage(translations.chatHints.internetIssueFirstMessage)} />
        <ChatHint text={translations.chatHints.securityIssue} icon={AlarmIcon} onClick={() => onMessage(translations.chatHints.securityIssueFirstMessage)} />
        <ChatHint text={translations.chatHints.maintenanceIssue} icon={ElectricityIcon} onClick={() => onMessage(translations.chatHints.maintenanceIssueFirstMessage)} />
        <ChatHint text={translations.chatHints.cleaningIssue} icon={HumidityLowIcon} onClick={() => onMessage(translations.chatHints.cleaningIssueFirstMessage)} />
    </ChatHints>
}

export default IssueReportingChatHints